<template>
  <th>
    <v-dialog v-model="dialog" max-width="500px" content-class="rounded-xl">
      <template v-slot:activator="{ value, on: dialog }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              :disabled="value"
              class="ma-2"
              small
              v-on="{ ...tooltip, ...dialog }"
            >
              <v-icon small>mdi-table</v-icon>
            </v-btn>
          </template>
          <span>Настройка столбцов</span>
        </v-tooltip>
      </template>
      <v-card class="rounded-xl">
        <v-card-title>
          <span class="headline">Настройка столбцов</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card class="mx-auto">
          <v-card-text>
            <h2 class="text-h6 mb-2">Об игре</h2>
            <v-chip-group v-model="cols" filter column multiple>
              <v-chip
                filter
                outlined
                v-for="col in all_cols_main"
                :key="col"
                :value="col"
              >
                {{ col }}
              </v-chip>
            </v-chip-group>
          </v-card-text>

          <v-card-text>
            <h2 class="text-h6 mb-2">Раунды</h2>
            <v-chip-group v-model="cols" filter column multiple>
              <v-chip
                filter
                outlined
                v-for="col in all_cols_finishes"
                :key="col"
                :value="col"
              >
                {{ col }}
              </v-chip>
            </v-chip-group>
          </v-card-text>

          <v-card-text>
            <h2 class="text-h6 mb-2">Время</h2>
            <v-chip-group v-model="cols" filter column multiple>
              <v-chip
                filter
                outlined
                v-for="col in all_cols_times"
                :key="col"
                :value="col"
              >
                {{ col }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
          <v-card-text>
            <h2 class="text-h6 mb-2">Тоталы</h2>
            <v-chip-group v-model="cols" filter column multiple>
              <v-chip
                filter
                outlined
                v-for="col in all_cols_totals"
                :key="col"
                :value="col"
              >
                {{ col }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-card>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="success" @click="successClicked">
            <v-icon>mdi-check</v-icon>
          </v-btn> -->
        <!-- <v-btn class="error" @click="dialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    entity: {
      type: String,
      default: "",
    },
    cf_type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      active: true,
      selected: "",
      selectedTime: [],
      all_cols_main: ["id", "Дата", "Время суток"],
      all_cols_finishes: [
        "Раунды",
        "П1Р | П2Р",
        "F | B | R",
        "П1 | П2",
        "Чистая победа",
      ],
      all_cols_times: [
        "Время",
        "Меньшее",
        "Среднее",
        "Большее",
        "Разница времени",
      ],
      all_cols_totals: [
        "5.5Б",
        "5.5М",
        "6.5М",
        "6.5Б",
        "7.5М",
        "7.5Б",
        "8.5М",
        "8.5Б",
      ],
      cur_cols: [],
      min_selected: "",
      max_selected: "",
      checkbox: false,
      selectedMultiple: [],
    };
  },
  methods: {
    // ...mapMutations(["addCol", "deleteCol", "setCols"]),
    ...mapActions(["setCols"]),
    ...mapGetters(["getSettings"]),

    // changed: function () {
    //   // console.log("Changed columns: " + this.cur_cols);
    //   this.setCols({ value: this.cur_cols });
    //   // console.log("Cur columns: " + this.cols());
    // },
  },
  computed: {
    cols: {
      get() {
        return this.getSettings().cols;
      },
      set(value) {
        this.setCols({ value: value });
      },
    },
  },
  created() {
    this.cur_cols = this.getSettings().cols;
    // console.log("Current columns:" + this.cur_cols);
  },
};
</script>

<style scoped></style>
